// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "7da14ea1dfd16f75b487133443e5e6dc" + ".js";
};